module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Langing-page.c1896d6a.jpg";